import { render, staticRenderFns } from "./erp-package.vue?vue&type=template&id=22e2bccc&scoped=true&"
import script from "./erp-package.vue?vue&type=script&lang=js&"
export * from "./erp-package.vue?vue&type=script&lang=js&"
import style0 from "./erp-package.vue?vue&type=style&index=0&id=22e2bccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2bccc",
  null
  
)

export default component.exports